export default __webpack_public_path__ + "static/media/long_textholder.c7f5cd82.png";